// DynamicTable.jsx
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { styled } from "@mui/material/styles";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Button } from "@material-ui/core";
import { CreateRule } from "td-rule-builder";
import { performData } from "../../utils";
import axios from "axios";
import { config } from '../../config';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { AlertContext } from "../../contexts";
import { AlertProps } from "../../utils";



const useStyles = makeStyles((theme) => ({
  Header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 16px",
    background: theme.palette.background.table,
    borderBottom: " 1px solid #e0e0e0",
  },
  Header2: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 16px",
    height: "52px",
    background: theme.palette.background.tableHeader,
  },
  wrapperdiv: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "16px",
    borderTop: " 1px solid #e0e0e0",
  },
  actionList: {
    padding: "8px 16px",
    height: "calc(100% - 114px)",
    overflowY: "auto",
  },
  actionListItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  wrapperdiv2: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "8px 16px",
  },
  wrapperdiv3: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    margin: "8px 16px 0 16px",
  },
  Table: {
    background: theme.palette.background.table,
    borderColor: theme.palette.border.textField,
    border: "1px solid",
    border: "1px solid",
    width: "90%",           // Make the table take full width
    maxWidth: "100%", 
    margin :"10px",
    marginLeft:"50px",
  },
  TableHeader: {
    background: theme.palette.background.tableHeader,
  },
  TableBody: {
    background: theme.palette.background.table,
  },
  Button: {
    background: theme.palette.button.background,
    color: theme.palette.button.text,
    "&:hover": {
      backgroundColor: theme.palette.button.hover,
    },
  },
  content: {
    height: "calc(100% - 55px)",
    padding: "16px",
    overflowY: "scroll",
    background: theme.palette.background.table,
  },
  style: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    // bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
    background: theme.palette.background.table,
    overflow: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  papers: {
    height: "100%",
    border: "1px solid #DCDCDC",
    background: theme.palette.background.table,
  },
  rulestyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "80%",
    // bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 3,
    overflowY: "scroll",
    background: theme.palette.background.table,
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  addNew: {
    fontSize: 15,
    cursor: "pointer",
    color: "#007AFF",
    fontFamily: "NunitoBold"
},
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.hover,
      // color: theme.palette.common.black,
      lineHeight: "0rem",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

const ActionRuleListComponenet = (props) => {
const classes = useStyles();
const alertMessage = React.useContext(AlertContext);
const [openCreateModal, setOpenCreateModal] = useState(false);
const [currentEditId, setCurrentEditId] = useState(null);
const {listRules,setListRule}= props;




React.useEffect(() => {
  if(props.editId){
    getRuleList(props.editId)
  }
  
}, [])

const getRuleList = async (ruleId) => {
    try {
      let params = {
        db_name: config.ruleBuilderDB,
        filter: {
          ruleId:ruleId
        },

        queryid:config.QdmQueryid.ListRulesId
      };
      let payload = {
        method: "post",
        url: config.read_qdmqueries_url,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      };
      await axios(payload)
        .then((res) => {
          let data = res?.data; 
          setListRule(data)
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

const ruleSoftDelete = async (id) => {
    try {
      let params = {
        db_name: config.ruleBuilderDB,
        entity: "Rules",
        filter: `Rules._id == '${id}'`,
        metadata_dbname: `${process.env.REACT_APP_MetadataDB_Name}`,
      };
      let payload = {
        method: "post",
        url: config.NodeRed_url_softDelete,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      };
      await axios(payload).then(async (res) => {
        // if (res) {
        // }
        let data = res?.data
        alertMessage?.setSnack({
          ...alertMessage,
          open: true,
          severity: AlertProps.severity.success,
          msg: "Rule Deleted Successfully",
          vertical: AlertProps.vertical.top,
          horizontal: AlertProps.horizontal.center,
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

const handleOpenCreate = () => {
  setCurrentEditId(null); // Clear edit mode
  setOpenCreateModal(true);
};

const handleEdit = (id) => {
  setCurrentEditId(id);
  setOpenCreateModal(true);
};

const handleDelete = (id) => {

  ruleSoftDelete(id)
  const idToRemove =id ;
const updatedWorkflow = (props?.scenarioStatemap?.workflow || []).filter(
  (id) => id !== idToRemove
);

props?.updateScenarios({
  ...props?.scenarioStatemap,
  workflow: updatedWorkflow
});
const updatedRules = listRules.filter(rule => rule._id !== id); 
  setListRule(updatedRules)
  if (props?.scenarioStatemap?.workflow) {
    const workFolwList = props.scenarioStatemap.workflow.filter(item => item !== id);
  
    props.setStateMap({
      ...props.scenarioStatemap,
      workflow: workFolwList
    });
  }
  
};

const handleClose = () => {
  setOpenCreateModal(false);
  setCurrentEditId(null);
};

const onSaveClicked = (data) => {
  if (!data) {
    handleCloseRule();
  
  } else {
    const newRuleProps = data.Result[0].properties;
    let isarrayCheckDuplicate =
    props?.scenarioStatemap?.workflow?.includes(newRuleProps.doc._id);

  if (isarrayCheckDuplicate) {
    handleCloseRule();
  } else {
    props?.updateScenarios(
      props?.scenarioStatemap?.workflow.push(newRuleProps.doc._id)
    );

  }
    const simplifiedRule = {
      ruleName:newRuleProps.doc.ruleName,
      _id: newRuleProps.doc._id,
    };
    setListRule(prevRules => {
      const index = prevRules.findIndex(rule => rule._id === simplifiedRule._id);
      if (index !== -1) {
        const updatedRules = [...prevRules];
        updatedRules[index] = simplifiedRule;
        return updatedRules;
      } else {
        return [...prevRules, simplifiedRule];
      }
    });
  }
  setOpenCreateModal(false)
};

const saveRuleList = (rulelist) => {
  const ids = rulelist.map(rulelist => rulelist._id);
  props?.editActionrule(ids);

}

const handleCloseRule = () => {
  setOpenCreateModal(false)
};

  return (
        <Box>
          {/* Button Section */}
          <Box
            mb={2} 
            mt={4}
            className={classes.Header}
          >
            <Typography  component="h6">
            Rules
            </Typography>
            <Typography variant="contained"
            onClick={handleOpenCreate}
            className={classes.addNew}
            >
              + ADD CRITERIA
            </Typography>
          </Box>
      
          {/* Table Section */}
          <Box display="flex" justifyContent="center" width="100%">
          <TableContainer>
            <Table
              size="small"
              aria-label="customized table"
              className={classes.Table}
            >
              <TableHead className={classes.TableHeader}>
                <TableRow>
                  <StyledTableCell width={5} align="left">
                    <pre> </pre>
                  </StyledTableCell>
                  <StyledTableCell width={5} align="left">
                    S.No
                  </StyledTableCell>
                  <StyledTableCell align="left">Criteria</StyledTableCell>
                  <StyledTableCell width={5} align="center">
                    Action
                  </StyledTableCell>
                </TableRow>
              </TableHead>
      
              <TableBody className={classes.TableBody}>
              {listRules && listRules.length > 0 ? (
               listRules?.map((rule, index) => (
                  <TableRow key={rule._id}>
                    <TableCell />
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{rule.ruleName}</TableCell>
                    <TableCell align="center">
                      <Box display="flex" justifyContent="center" alignItems="center">
                        <IconButton
                          size="small"
                          onClick={() => handleEdit(rule._id)}
                          sx={{ marginRight: 1 }}
                        >
                          <EditOutlinedIcon color="primary" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleDelete(rule._id)}
                        >
                          <DeleteOutlineIcon color="error" />
                        </IconButton>
                      </Box>
                    </TableCell>

                  </TableRow>
                ))
              ):
              (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )
            }
            </TableBody>
            </Table>
          </TableContainer>
          </Box>

       
          <Modal open={openCreateModal} onClose={handleClose}>
          <Box className={classes.rulestyle}>
          <CreateRule
            handleClose={(data) => {
              onSaveClicked(data);
            }}
            inputSchema={props?.inputSchema}
            open={true}
            performvalueData={{
              stateList: props.stateList,
              scenarioList: props?.scenarioList,
              queueList: JSON.parse(sessionStorage.getItem("queueList")),
              userRole: JSON.parse(sessionStorage.getItem("userAssignee")),
              userGroup: JSON.parse(sessionStorage.getItem("userGroup")),
            }}
            performKeyData={performData}
            dbName={`${process.env.REACT_APP_DB}`}
            editId={currentEditId}
          />



        </Box>
      </Modal>
      <Box display="flex" justifyContent="flex-end" p={5}>
    <Button
        variant="contained"
        color="primary"
        onClick={() => {
          saveRuleList(listRules); 
        }}
      >
        OK
      </Button>
    </Box>
          
    </Box>


);
      
};

export default ActionRuleListComponenet;
